module.exports = __webpack_public_path__ + "static/media/avatars_all_23.d297249c.png";